import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { Col, Row } from 'reactstrap';
import SectionTitle from '../../../../../components/Text/SectionTitle';
import { isNumber } from '../../../../../utils/math';
import StudentTabsHeader from '../StudentTabsHeader';
import { useTexts } from './hooks/useTexts';
import { DocumentsOthersTable } from './parts/DocumentsOthersTable';
import { DocumentsTuitionTable } from './parts/DocumentsTuitionTable';
import { StudentDocumentsLoader } from './parts/StudentDocumentsLoader';
import { StudentDocument } from './types';

export function StudentDocuments() {
  const texts = useTexts();

  const { studentId } = useParams<{ studentId: string }>();
  const studentIdInt = useMemo(() => {
    if (isNumber(studentId)) {
      return Number(studentId);
    }
    return null;
  }, [studentId]);
  if (!studentIdInt) {
    throw new Error('Invalid studentId');
  }

  return (
    <StudentDocumentsLoader studentId={studentIdInt}>
      {({ data, refresh }) => (
        <>
          <StudentTabsHeader
            id={data.student.rut}
            name={data.student.fullName}
          />
          <div className="my-4">
            <SectionTitle text={texts.documentsTuitionTitle} />
          </div>
          <div className="my-4">
            <DocumentsTuitionTable
              studentId={studentIdInt}
              data={data.documentsTuition}
            />
          </div>
          <Row className="my-4">
            <Col>
              <SectionTitle text={texts.documentsOthersTitle} />
            </Col>
          </Row>
          <div className="my-4">
            <DocumentsOthersTable
              studentId={studentIdInt}
              data={data.documentsOther}
              hasPermissionToDelete={false}
              onDelete={(document: StudentDocument) => {}}
            />
          </div>
        </>
      )}
    </StudentDocumentsLoader>
  );
}
